export enum ETableLayoutStyle {
  ABSOLUTE_WITH_TOP_BOTTOM = 'absolute-with-top-bottom',
  FLEX = 'flex',
  NONE = 'none',
}
